import { ClaimReportGetAdapter } from '../../../adapter';

export default async function ClaimReportGetUseCase() {
    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcc.dev.bpimsapps.com');
    const isUAT = url.includes('hcc.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionclaims.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
        ? 'https://partners-api.dev.bpimsapps.com/claim/report/get'
        : isUAT
        ? 'https://partners-api.uat.bpimsapps.com/claim/report/get'
        : isProd
        ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/report/get`
        : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/report/get`;

    const payload = {
        policyPayload: {
            search: '',
            page: 1,
            size: null
        },
        claimsPayload: {}
    };

    // handle request
    const result = await ClaimReportGetAdapter(endpoint, JSON.stringify(payload));

    return result;
}
